import { render, staticRenderFns } from "./ApplicationToolBoxMessage.vue?vue&type=template&id=663fbb10&"
import script from "./ApplicationToolBoxMessage.vue?vue&type=script&lang=js&"
export * from "./ApplicationToolBoxMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../var/www/laravel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports